import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/contextAuth";
import { useThemeMode } from "../context/contextTheme";
import { useProfile } from "../context/contextProfile";
import { useNavigate, Link } from "react-router-dom";
import Loader3 from "../components/loaders/Loader-3";
import LogoImg from "../assets/img/logo/Save-Logo-Blue-2.png";

export default function SignUpPage() {
  const { theme, mode } = useThemeMode();
  const { loadingAuth, getSignup, signUp, setSignUp } = useAuth();
  const { zoomLevel } = useProfile();
  const { uuid } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [fullName, setFullName] = useState("");
  const [company, setCompany] = useState("");
  const [designation, setDesignation] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    const [firstName, ...lastNameParts] = fullName.trim().split(" ");
    const lastName = lastNameParts.join(" ");

    const data = {
      username,
      password,
      first_name: firstName,
      last_name: lastName,
      company,
      designation,
      email,
      phone_number: phoneNumber,
    };

    try {
      const response = await getSignup(data,  uuid, token);
      if (response.error) {
        setError(response.error);
      } else {
        setSignUp(true);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    if (signUp) {
      const timeout = setTimeout(() => {
        navigate("/signin");
        setSignUp(false);
      }, 3000);
      return () => clearTimeout(timeout);
    }
  }, [signUp, navigate, setSignUp]);

  useEffect(() => {
    document.body.style.backgroundImage =
      "radial-gradient(circle at center, #302158, #100021)";
    document.body.style.height = "100vh";
    document.body.style.margin = "0";
    document.body.style.overflow = "hidden";
  }, [mode, theme.background]);

  return (
    <>
      {loadingAuth ? (
        <Loader3 />
      ) : (
        <div className="position-absolute top-50 start-50 translate-middle w-100 d-flex justify-content-center">
          <div
            className="bg-white rounded-4 shadow-lg p-5 custom-scrollbar"
            style={{
              transform: `scale(${zoomLevel})`,
              maxWidth: 600,
              maxHeight: "90vh",
              overflowY: "auto"
            }}
          >
            {signUp ? (
              <SuccessState />
            ) : (
              <>
                {/* Logo */}
                <div className="text-center mb-4">
                  <img src={LogoImg} alt="Logo" height={50} />
                </div>

                {/* Header */}
                <div className="text-center mb-4">
                  <h4 className="fw-bold text-dark">
                    Create Account
                  </h4>
                  <p className="text-secondary small">
                    Fill in the details below to get started.
                  </p>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="row g-3">

                    <div className="col-md-6">
                      <label className="form-label small fw-semibold">
                        Full Name
                      </label>
                      <input
                        type="text"
                        className="form-control rounded-3 bg-light"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        placeholder="John Doe"
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label small fw-semibold">
                        Username
                      </label>
                      <input
                        type="text"
                        className="form-control rounded-3 bg-light"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="john.doe"
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label small fw-semibold">
                        Company
                      </label>
                      <input
                        type="text"
                        className="form-control rounded-3 bg-light"
                        value={company}
                        onChange={(e) => setCompany(e.target.value)}
                        placeholder="Acme Inc."
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label small fw-semibold">
                        Designation
                      </label>
                      <input
                        type="text"
                        className="form-control rounded-3 bg-light"
                        value={designation}
                        onChange={(e) => setDesignation(e.target.value)}
                        placeholder="Software Engineer"
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label small fw-semibold">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control rounded-3 bg-light"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="john@example.com"
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label small fw-semibold">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        className="form-control rounded-3 bg-light"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        placeholder="+1 555-0100"
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label small fw-semibold">
                        Password
                      </label>
                      <input
                        type="password"
                        className="form-control rounded-3 bg-light"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="••••••••"
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label small fw-semibold">
                        Confirm Password
                      </label>
                      <input
                        type="password"
                        className="form-control rounded-3 bg-light"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="••••••••"
                        required
                      />
                    </div>
                  </div>

                  {error && (
                    <div className="alert alert-danger mt-3 text-center small">
                      {error}
                    </div>
                  )}

                  <button
                    type="submit"
                    className="btn w-100 fw-bold rounded-3 mt-4"
                    style={{
                      backgroundColor: "#0ea5e9",
                      color: "#fff",
                      padding: "12px"
                    }}
                  >
                    Register
                  </button>

                  <div className="text-center mt-3 small text-secondary">
                    Already have an account?{" "}
                    <Link
                      to="/signin"
                      className="fw-bold text-decoration-none"
                      style={{ color: "#0ea5e9" }}
                    >
                      Sign In
                    </Link>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}

      <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 6px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbcbcb; border-radius: 10px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; margin-top: 15px; margin-bottom: 15px; }
      `}</style>
    </>
  );
}

const SuccessState = () => {
  return (
    <div className="text-center py-5">
      <i
        className="bi bi-check-circle-fill text-success mb-3"
        style={{ fontSize: "4rem" }}
      ></i>
      <h4 className="fw-bold text-dark">
        Registration Successful!
      </h4>
      <p className="text-secondary small">
        Your account has been created successfully.
        <br />
        Redirecting you to sign in...
      </p>
    </div>
  );
};